import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export function useBlockUser() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({
      targetUserId,
      reason,
    }: {
      targetUserId: string
      reason?: string
    }) => {
      const { data, error } = await supabase.rpc('block_user', {
        _target_user_id: targetUserId,
        _reason: reason ?? null,
      })
      if (error) throw error
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['conversations'] })
      qc.invalidateQueries({ queryKey: ['conversation'] })
    },
  })
}
